(() => {
  const initPurchase = (root) => {
    if (!root || root.dataset.drReady === 'true') return;
    root.dataset.drReady = 'true';

    const pricingEl = root.querySelector('[data-dr-pricing]');
    let pricing = {};
    try { pricing = JSON.parse(pricingEl?.textContent || '{}'); } catch (e) { pricing = {}; }

    const variant = root.querySelector('[data-dr-variant]');
    const hiddenVariant = root.querySelector('input[name="id"][type="hidden"]');
    const price = root.querySelector('[data-dr-price]');
    const compare = root.querySelector('[data-dr-compare]');
    const saving = root.querySelector('[data-dr-saving]');
    const note = root.querySelector('[data-dr-price-note]');
    const subSummary = root.querySelector('[data-dr-sub-summary]');
    const subBadge = root.querySelector('[data-dr-sub-badge]');
    const add = root.querySelector('[data-dr-add]');
    const planInput = root.querySelector('[data-dr-selling-plan]');
    const qty = root.querySelector('[data-dr-qty]');

    const currentVariantId = () => variant?.value || hiddenVariant?.value || '';
    const currentPlanId = () => root.querySelector('[data-dr-plan]:checked')?.dataset.drPlan || '';
    const savingMeta = (compareCents, priceCents) => {
      const base = Number(compareCents || 0);
      const now = Number(priceCents || 0);
      const diff = Math.max(0, base - now);
      const pct = base > 0 ? Math.round((diff / base) * 100) : 0;
      return { diff, pct, label: pct > 0 ? `Save ${pct}%` : '' };
    };

    const updatePrice = () => {
      const data = pricing[String(currentVariantId())];
      if (!data) return;
      const planId = currentPlanId();
      const allocation = planId ? data.plans?.[String(planId)] : null;

      if (allocation) {
        if (price) price.textContent = allocation.price;
        const meta = savingMeta(allocation.compareCents, allocation.priceCents);
        if (compare) {
          compare.textContent = allocation.compare;
          compare.hidden = !(allocation.compareCents > allocation.priceCents);
        }
        if (saving) {
          saving.textContent = meta.label;
          saving.hidden = !meta.label;
        }
        if (note) {
          note.textContent = `${allocation.price} per delivery${allocation.planName ? ` · ${allocation.planName}` : ''}`;
          note.hidden = false;
        }
        if (subSummary) subSummary.textContent = `${allocation.price} per delivery${meta.label ? ` · ${meta.label}` : ''}`;
        if (subBadge) subBadge.textContent = meta.label || subBadge.dataset.fallback || 'Save';
        if (planInput) planInput.value = planId;
      } else {
        if (price) price.textContent = data.oneTime.price;
        if (compare) compare.hidden = true;
        if (saving) saving.hidden = true;
        if (note) note.hidden = true;
        if (planInput) planInput.value = '';
        const firstPlan = Object.values(data.plans || {})[0];
        if (firstPlan && subSummary) {
          const meta = savingMeta(firstPlan.compareCents, firstPlan.priceCents);
          subSummary.textContent = `${firstPlan.price} per delivery${meta.label ? ` · ${meta.label}` : ''}`;
          if (subBadge) subBadge.textContent = meta.label || subBadge.dataset.fallback || 'Save';
        }
      }

      const available = data.available !== false;
      if (add) {
        add.disabled = !available;
        add.textContent = available ? (add.dataset.label || 'Add to cart') : 'Sold out';
      }
    };

    root.querySelector('[data-dr-minus]')?.addEventListener('click', () => {
      if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1);
    });
    root.querySelector('[data-dr-plus]')?.addEventListener('click', () => {
      if (qty) qty.value = Math.max(1, Number(qty.value || 1) + 1);
    });
    root.querySelectorAll('[data-dr-plan]').forEach((radio) => radio.addEventListener('change', () => {
      root.querySelectorAll('.drbuy__option').forEach((option) => option.classList.toggle('is-selected', option.contains(radio) && radio.checked));
      updatePrice();
    }));
    variant?.addEventListener('change', updatePrice);
    updatePrice();
  };

  const initAll = () => document.querySelectorAll('[data-dr-purchase]').forEach(initPurchase);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
